export default {
  SET_MERGED_INVOICES: function (state, payloads) {
    state.mergedInvoices = payloads;
  }
}
